import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface TitleListItem {
  _id: string;
  EAN: number;
  SEASON: string;
  GROUP_1: string;
  TESTIMPRINTFROMHNA: string;
  FULL_TITLE: string;
  AUTHOR_1: string;
  PUB_DATE: string;
  RELEASE_DATE: string;
  FORMAT: string;
  US_PRICE: number;
  //   //Float + Blank
  //   pubGoalTotal: "PUB GOAL (TOTAL)";
  //   totalCurrentEstimate: "TOTAL CURRENT ESTIMATE";
  //   estimatePubGoal: "ESTIMATE VS PUB GOAL";
  //   totalInitialOrders: "TOTAL INITIAL ORDERS";
}
interface rls{
  COLUMN:any;
  VALUE:any
}

interface sortObj {
  heading:string;
  sortType:string;
}
interface TitleListState {
  data: TitleListItem[];
  dataOfRls:rls[];
  status: string;
  hasMore: boolean;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  page: number;
  prevPage: number;
  limit: number;
  selectedRowIndex: number | any;
  titleSortBy: sortObj;
}
const initialState: TitleListState = {
  data: [],
  dataOfRls: [{ COLUMN: "0", VALUE: "0" }],
  page: 1,
  limit: 25,
  status: "",
  hasMore: false,
  error: null,
  statusCode: 0,
  isLoading: false,
  selectedRowIndex: 0,
  prevPage: 1,
  titleSortBy: {
    heading:"FULL_TITLE",
    sortType:"desc"
  }
};

export const FetchTitleListRecord = createAsyncThunk(
  "FetchTitleListRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.POSTTitleListData, data);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);
export const RLSApi = createAsyncThunk(
  "RlsApi/fetch",
  async (data: { email: string; report_id: string }, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.RlsApi, data);
      return response.data; // payload for the fulfilled action
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const TitleListSlice = createSlice({
  name: "TitleListData",
  initialState,
  reducers: {
    emptyTitleListPage: (state) => {
      state.page = initialState.page;
      state.data = initialState.data;
      state.selectedRowIndex = initialState.selectedRowIndex;
      state.prevPage = initialState.prevPage;
      state.status = initialState.status;
      state.statusCode = initialState.statusCode;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.limit = initialState.limit;
      state.hasMore = initialState.hasMore;
    },
    UpdatePagination: (state) => {
      state.page = state.page + 1;
    },
    resetTitleListPage: (state) => {
      state.page = initialState.page;
    },
    emptyPreviousTitleListRecords: (state) => {
      state.data = initialState.data;
    },
    setSelectedRowIndex: (state, action) => {
      state.selectedRowIndex = action.payload;
    },
    updatePrevPage: (state, action) => {
      state.prevPage = action.payload;
    },
    titleListSortByDesc: (state,action ) =>{
      console.log(action.payload)
      state.titleSortBy = action.payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.hasMore = action.payload.hasMore;

        const requestedPage = action.meta?.arg?.page ?? 1;

        if (action.payload.filteredNew || requestedPage === 1) {
          // New filter set or explicit first‑page fetch – replace data.
          state.data = action.payload.TitleLists;
          state.page = requestedPage;
          state.selectedRowIndex = 0;
        } else {
          // Subsequent pages for the same filter set – append.
          state.data.push(...action.payload.TitleLists);
        }
      })
      .addCase(FetchTitleListRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      })
      .addCase(RLSApi.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(RLSApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.dataOfRls=action.payload.data
        console.log(action.payload.data,'dataofrls')
      })
      .addCase(RLSApi.rejected, (state) => {
        state.isLoading = false;
        state.dataOfRls = [{ COLUMN: null, VALUE: null }];
        state.status = "Failed";
        state.error = "Error";
      })
   
  },
});

export const {
  emptyTitleListPage,
  titleListSortByDesc,
  resetTitleListPage,
  UpdatePagination,
  emptyPreviousTitleListRecords,
  setSelectedRowIndex,
  updatePrevPage,
} = TitleListSlice.actions;
export default TitleListSlice.reducer;
